// Exposed as `posthog-js/rrweb-plugin-console-record` via packages/browser/rrweb-plugin-console-record/package.json.
export * from '@posthog/rrweb-plugin-console-record'
